import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// Utils
import { useTranslateHook } from '@/main/hooks/translateHook';
import { evaluationCompanyBuyerApi } from '@/main/api';
import {
  getParamsToGetTranslatesPublic,
  getTranslateByKey,
  isEmpty
} from '@/main/services/utils';
import { KeyValue } from '@/main/models/common';

// Components
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import ResultNotFoundComponent from '@/main/components/shared/resultNotFound/resultNotFoundComponent';

// Styles & icons
import * as S from './styles';
import { CartCheckIcon } from '@/main/components/shared/icons/cartCheckIcon';
import header from '../../../assets/images/evaluate/default_header.png';
import footer from '../../../assets/images/evaluate/default_footer.png';
import { SaveSupplierEvaluationRequest } from '@/main/models/request/evaluationSupplierRequest';

function EvaluationSupplierScreen() {
  const [searchParams] = useSearchParams();
  const guidSupplierParams = searchParams.get('guidSupplier');
  const guidProcurementParams = searchParams.get('guidProcurement');
  const evaluationScoreParams = searchParams.get('rating');
  const cultureUserParams = searchParams.get('cultureUser') || '{}';

  const [isLoadingSave, setIsLoadingSave] = useState(true);
  const [isError, setIsError] = useState(false);
  const [messageResponse, setMessageResponse] = useState('');

  const translatesPage = [
    't.nah.information.evaluateThank',
    't.nah.information.evaluateThankSincerely',
    't.nah.information.evaluateAlready',
    't.nah.information.anUnexpectedErrorOccurredPleaseTryAgainLater',
    'e.nah.information.EvaluationWasAlreadyDone'
  ];
  const {
    isLoadingTranslates,
    translatesLocal,
    getTranslates
  } = useTranslateHook({
    filter: {
      keysList: translatesPage
    },
    fillTranslateLocal: true
  });

  function callSaveEvaluationPublicApi() {
    const requestForm: SaveSupplierEvaluationRequest = {
      guidProcurement: String(guidProcurementParams),
      guidSupplier: String(guidSupplierParams),
      evaluationScore: Number(evaluationScoreParams),
      evaluationDescription: null,
      ignoreSupplierEvaluation: false
    };

    evaluationCompanyBuyerApi
      .saveEvaluationPublic(requestForm)
      .then(() => {
        const message = 'information.evaluateThank';
        setMessageResponse(message);
      })
      .catch(error => {
        const errorResponse = error.response.data;
        const isErrorToken = errorResponse.errorMessages.find(
          (x: KeyValue) => x.key == 'e.nah.information.invalidToken'
        );
        if (isErrorToken) {
          setIsError(true);
          return;
        }
        const message = errorResponse.errorMessages.find(
          (x: KeyValue) => x.key == 'e.nah.information.evaluationWasAlreadyDone'
        )
          ? 'information.evaluateAlready'
          : 'information.somethingWrong';
        setMessageResponse(message);
      })
      .finally(() => {
        setIsLoadingSave(false);
      });
  }

  useEffect(() => {
    callSaveEvaluationPublicApi();
    const { lastSyncTranslations } = getParamsToGetTranslatesPublic(
      cultureUserParams
    );
    getTranslates({ culture: cultureUserParams, lastSyncTranslations });
  }, []);

  if (isError) return <ResultNotFoundComponent messageCustom={''} />;

  if (isLoadingTranslates || isLoadingSave || isEmpty(messageResponse))
    return <LoadingComponent />;

  return (
    <S.Background>
      <S.BoxForm>
        <S.Header>
          <img src={header} />
        </S.Header>
        <S.Message>
          <S.Title>
            {getTranslateByKey(messageResponse, false, translatesLocal)}
          </S.Title>
          <CartCheckIcon />
          <S.Paragraph>
            {getTranslateByKey(
              'information.evaluateThankSincerely',
              false,
              translatesLocal
            )}
          </S.Paragraph>
        </S.Message>
        <S.Footer>
          <img src={footer} />
        </S.Footer>
      </S.BoxForm>
    </S.Background>
  );
}

export default EvaluationSupplierScreen;
